'use strict';

var Misc = require('utils/misc');

var SelectView = Marionette.LayoutView.extend({
    template: require('components/common/templates/select_picker'),

    serializeData: function () {
        return this.options;
    },

    onRender: function () {
        Misc.initSelectPicker();
    },

    onShow: function () {
        Misc.initSelectPicker();
    },
});

module.exports = SelectView;
